var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({ callback: _vm.visibilityChanged, throttle: 2000, }),expression:"{ callback: visibilityChanged, throttle: 2000, }"}],staticClass:"slideshow",class:{
    'slideshow--reversed': _vm.reversed,
    'slideshow--semi': _vm.semi,
   }},[_c('div',{staticClass:"img",class:{ 'img--visible': _vm.isImageVisible }},_vm._l((_vm.images),function(img,i){return _c('img',{key:`image-${i}`,attrs:{"src":img}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }